import React, { useState, useEffect } from 'react';
import contentService from '../services/contentService';
import CompetenciaModal from './CompetenciaModal';
import InformeCompetidorModal from './InformeCompetidorModal';
import Loading from './Loading';
import './InfluencerList.css';
import './CompetenciaList.css';

const CompetenciaPostsModal = ({ competidor, onClose }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPosts = async () => {
    setLoading(true);
    setError(null);
    try {
      // Intento 1: Meta Business Discovery (gratuito, sin costo de unidades)
      const res = await contentService.getIGBusinessDiscovery({
        username: competidor.ig_username || competidor.username,
        include_media: '1',
        media_limit: 20,
      });
      const media = res.data?.business_discovery?.media?.data || [];
      if (media.length > 0) {
        setPosts(media);
        return;
      }
      throw new Error('Sin resultados en Business Discovery');
    } catch (igErr) {
      // Intento 2: EnsembleData (cubre cuentas personales también)
      try {
        const res2 = await contentService.getEnsembleDataIGPosts(competidor.ig_username || competidor.username, 20);
        const posts2 = res2.data?.posts || [];
        setPosts(posts2);
      } catch (edErr) {
        console.error('Error fetching IG posts (BD + ED):', igErr, edErr);
        setError('No se pudieron obtener las publicaciones. Verifica que el usuario de Instagram sea correcto y tenga una cuenta pública.');
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (ts) => {
    if (!ts) return '—';
    return new Date(ts).toLocaleDateString('es-CL', {
      day: '2-digit', month: 'short', year: 'numeric',
    });
  };

  const mediaIcon = (type) => {
    if (type === 'VIDEO') return '🎬';
    if (type === 'CAROUSEL_ALBUM') return '📎';
    return '🖼️';
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
        zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '16px',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff', borderRadius: '12px', width: '100%', maxWidth: '760px',
          maxHeight: '85vh', display: 'flex', flexDirection: 'column',
          boxShadow: '0 8px 40px rgba(0,0,0,0.22)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: '16px 20px', borderBottom: '1px solid #e5e7eb',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '17px', fontWeight: 700 }}>
              Últimas publicaciones — @{competidor.ig_username || competidor.username}
            </h2>
            <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#6b7280' }}>
              Likes y comentarios en Instagram
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: '20px', color: '#6b7280', lineHeight: 1,
            }}
          >✕</button>
        </div>

        {/* Body */}
        <div style={{ overflowY: 'auto', flex: 1, padding: '8px 0' }}>
          {loading && (
            <Loading fullScreen={false} mensaje="Obteniendo publicaciones" />
          )}
          {!loading && error && (
            <div style={{ padding: '32px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>⚠️</div>
              <p style={{ color: '#ef4444', fontSize: '14px', maxWidth: '480px', margin: '0 auto' }}>{error}</p>
              <button onClick={fetchPosts} className="estado-btn" style={{ marginTop: '12px' }}>
                Reintentar
              </button>
            </div>
          )}
          {!loading && !error && posts.length === 0 && (
            <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280', fontSize: '14px' }}>
              No se encontraron publicaciones para esta cuenta.
            </div>
          )}
          {!loading && !error && posts.length > 0 && (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#374151', width: '56px' }}>#</th>
                  <th style={{ padding: '10px 8px', textAlign: 'left', fontWeight: 600, color: '#374151', width: '72px' }}>Imagen</th>
                  <th style={{ padding: '10px 8px', textAlign: 'left', fontWeight: 600, color: '#374151' }}>Publicación</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: 600, color: '#374151', width: '90px' }}>📅 Fecha</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: 600, color: '#374151', width: '80px' }}>❤️ Likes</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', fontWeight: 600, color: '#374151', width: '100px' }}>💬 Coment.</th>
                </tr>
              </thead>
              <tbody>
                {posts.map((post, idx) => {
                  const thumb = post.thumbnail_url || post.media_url;
                  const caption = (post.caption || '').slice(0, 100);
                  return (
                    <tr
                      key={post.id}
                      style={{ borderBottom: '1px solid #f3f4f6', background: idx % 2 === 0 ? '#fff' : '#fafafa' }}
                    >
                      <td style={{ padding: '10px 12px', color: '#9ca3af', fontWeight: 500 }}>
                        {mediaIcon(post.media_type)} {idx + 1}
                      </td>
                      <td style={{ padding: '8px' }}>
                        {thumb ? (
                          <a href={post.permalink} target="_blank" rel="noreferrer">
                            <img
                              src={thumb}
                              alt="post"
                              style={{
                                width: '56px', height: '56px', objectFit: 'cover',
                                borderRadius: '6px', display: 'block',
                              }}
                              onError={(e) => { e.target.style.display = 'none'; }}
                            />
                          </a>
                        ) : (
                          <div style={{
                            width: '56px', height: '56px', background: '#f3f4f6',
                            borderRadius: '6px', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', fontSize: '20px',
                          }}>
                            {mediaIcon(post.media_type)}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '8px', color: '#374151', lineHeight: '1.4' }}>
                        {caption ? (
                          <span title={post.caption}>{caption}{post.caption?.length > 100 ? '…' : ''}</span>
                        ) : (
                          <span style={{ color: '#d1d5db', fontStyle: 'italic' }}>Sin caption</span>
                        )}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'center', color: '#6b7280' }}>
                        {formatDate(post.timestamp)}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'center', fontWeight: 600, color: '#ef4444' }}>
                        {post.like_count?.toLocaleString('es-CL') ?? '—'}
                      </td>
                      <td style={{ padding: '8px', textAlign: 'center', fontWeight: 600, color: '#3b82f6' }}>
                        {post.comments_count?.toLocaleString('es-CL') ?? '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ background: '#f0f9ff', borderTop: '2px solid #e5e7eb', fontWeight: 700 }}>
                  <td colSpan={4} style={{ padding: '10px 12px', color: '#374151' }}>
                    Total ({posts.length} posts)
                  </td>
                  <td style={{ padding: '10px 8px', textAlign: 'center', color: '#ef4444' }}>
                    {posts.reduce((s, p) => s + (p.like_count || 0), 0).toLocaleString('es-CL')}
                  </td>
                  <td style={{ padding: '10px 8px', textAlign: 'center', color: '#3b82f6' }}>
                    {posts.reduce((s, p) => s + (p.comments_count || 0), 0).toLocaleString('es-CL')}
                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};


const CompetenciaTikTokModal = ({ competidor, onClose }) => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchVideos = async () => {
    setLoading(true);
    setError(null);
    try {
      // Intento 1: EnsembleData (más rápido ~5-15s, menor costo)
      const res = await contentService.getEnsembleDataTikTokPosts(competidor.tk_username || competidor.username, 20);
      const videos = res.data?.videos || [];
      if (videos.length > 0) {
        setVideos(videos);
        return;
      }
      throw new Error('Sin resultados en EnsembleData');
    } catch (edErr) {
      // Intento 2: Apify como fallback (más lento, 20-40s)
      try {
        const res2 = await contentService.getTikTokCompetitorPosts(competidor.tk_username || competidor.username, 20);
        setVideos(res2.data?.videos || []);
      } catch (apifyErr) {
        console.error('Error fetching TikTok videos (ED + Apify):', edErr, apifyErr);
        setError(
          apifyErr.code === 'ECONNABORTED'
            ? 'Tiempo de espera agotado. Intenta de nuevo más tarde.'
            : 'No se pudieron obtener los videos. Verifica que el usuario de TikTok sea correcto y sea público.'
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (ts) => {
    if (!ts) return '—';
    return new Date(ts).toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const fmt = (n) => (n ?? 0).toLocaleString('es-CL');

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 10000,
               display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}
      onClick={onClose}
    >
      <div
        style={{ background: '#fff', borderRadius: '12px', width: '100%', maxWidth: '800px',
                 maxHeight: '85vh', display: 'flex', flexDirection: 'column',
                 boxShadow: '0 8px 40px rgba(0,0,0,0.22)' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '17px', fontWeight: 700 }}>
              Últimos videos TikTok — @{competidor.tk_username || competidor.username}
            </h2>
            <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#6b7280' }}>
              Likes, comentarios y reproducciones
            </p>
          </div>
          <button onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#6b7280' }}>
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={{ overflowY: 'auto', flex: 1, padding: '8px 0' }}>
          {loading && (
            <Loading fullScreen={false} mensaje="Obteniendo data" />
          )}
          {!loading && error && (
            <div style={{ padding: '32px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>⚠️</div>
              <p style={{ color: '#ef4444', fontSize: '14px', maxWidth: '480px', margin: '0 auto' }}>{error}</p>
              <button onClick={fetchVideos} className="estado-btn" style={{ marginTop: '12px' }}>
                Reintentar
              </button>
            </div>
          )}
          {!loading && !error && videos.length === 0 && (
            <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280', fontSize: '14px' }}>
              No se encontraron videos para @{competidor.tk_username || competidor.username}.
            </div>
          )}
          {!loading && !error && videos.length > 0 && (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                  <th style={{ padding: '10px 12px', textAlign: 'left', width: '48px' }}>#</th>
                  <th style={{ padding: '10px 8px', width: '64px' }}>Cover</th>
                  <th style={{ padding: '10px 8px', textAlign: 'left' }}>Descripción</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', width: '90px' }}>📅 Fecha</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', width: '80px' }}>❤️ Likes</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', width: '90px' }}>💬 Coment.</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', width: '90px' }}>▶️ Views</th>
                </tr>
              </thead>
              <tbody>
                {videos.map((v, idx) => (
                  <tr key={v.id || idx}
                    style={{ borderBottom: '1px solid #f3f4f6', background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '10px 12px', color: '#9ca3af', fontWeight: 500 }}>🎬 {idx + 1}</td>
                    <td style={{ padding: '8px' }}>
                      {v.thumbnail_url ? (
                        <a href={v.permalink} target="_blank" rel="noreferrer">
                          <img src={v.thumbnail_url} alt="cover"
                            style={{ width: '48px', height: '64px', objectFit: 'cover', borderRadius: '6px', display: 'block' }}
                            onError={(e) => { e.target.style.display = 'none'; }} />
                        </a>
                      ) : (
                        <div style={{ width: '48px', height: '64px', background: '#f3f4f6', borderRadius: '6px',
                                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>
                          🎬
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '8px', color: '#374151', lineHeight: '1.4', maxWidth: '260px' }}>
                      {v.caption ? (
                        <span title={v.caption}>
                          {v.caption.slice(0, 120)}{v.caption.length > 120 ? '…' : ''}
                        </span>
                      ) : (
                        <span style={{ color: '#d1d5db', fontStyle: 'italic' }}>Sin descripción</span>
                      )}
                    </td>
                    <td style={{ padding: '8px', textAlign: 'center', color: '#6b7280' }}>{formatDate(v.timestamp)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontWeight: 600, color: '#ef4444' }}>{fmt(v.like_count)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontWeight: 600, color: '#3b82f6' }}>{fmt(v.comment_count)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontWeight: 600, color: '#10b981' }}>{fmt(v.play_count)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ background: '#f0fdf4', borderTop: '2px solid #bbf7d0', fontWeight: 700 }}>
                  <td colSpan={4} style={{ padding: '10px 12px', color: '#374151' }}>
                    Total ({videos.length} videos)
                  </td>
                  <td style={{ padding: '10px 8px', textAlign: 'center', color: '#ef4444' }}>
                    {fmt(videos.reduce((s, v) => s + (v.like_count || 0), 0))}
                  </td>
                  <td style={{ padding: '10px 8px', textAlign: 'center', color: '#3b82f6' }}>
                    {fmt(videos.reduce((s, v) => s + (v.comment_count || 0), 0))}
                  </td>
                  <td style={{ padding: '10px 8px', textAlign: 'center', color: '#10b981' }}>
                    {fmt(videos.reduce((s, v) => s + (v.play_count || 0), 0))}
                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};


const CompetenciaFacebookModal = ({ competidor, onClose }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPosts = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await contentService.getSociaVaultFacebookPosts(competidor.fb_username, 20);
      setPosts(res.data?.posts || []);
    } catch (err) {
      console.error('Error fetching FB posts:', err);
      setError('No se pudieron obtener las publicaciones. Verifica que el usuario de Facebook sea correcto y sea una página pública.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (ts) => {
    if (!ts) return '—';
    return new Date(ts).toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const fmt = (n) => (n ?? 0).toLocaleString('es-CL');

  const mediaIcon = (type) => type === 'VIDEO' ? '🎬' : '🖼️';

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 10000,
               display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}
      onClick={onClose}
    >
      <div
        style={{ background: '#fff', borderRadius: '12px', width: '100%', maxWidth: '800px',
                 maxHeight: '85vh', display: 'flex', flexDirection: 'column',
                 boxShadow: '0 8px 40px rgba(0,0,0,0.22)' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ background: '#1877f2', padding: '16px 20px', borderRadius: '12px 12px 0 0',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img
              src="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/faccebook.webp"
              alt="Facebook"
              style={{ width: '24px', height: '24px', objectFit: 'contain', borderRadius: '4px' }}
            />
            <div>
              <h2 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#fff' }}>
                Últimas publicaciones — @{competidor.fb_username}
              </h2>
              <p style={{ margin: '2px 0 0', fontSize: '13px', color: 'rgba(255,255,255,0.8)' }}>
                Reacciones y comentarios en Facebook
              </p>
            </div>
          </div>
          <button onClick={onClose}
            style={{ background: 'rgba(255,255,255,0.2)', border: 'none', cursor: 'pointer',
                     fontSize: '18px', color: '#fff', borderRadius: '50%',
                     width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={{ overflowY: 'auto', flex: 1, padding: '8px 0' }}>
          {loading && (
            <Loading fullScreen={false} mensaje="Obteniendo data" />
          )}
          {!loading && error && (
            <div style={{ padding: '32px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>⚠️</div>
              <p style={{ color: '#ef4444', fontSize: '14px', maxWidth: '480px', margin: '0 auto 12px' }}>{error}</p>
              <a
                href={`https://www.facebook.com/${competidor.fb_username}`}
                target="_blank" rel="noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', gap: '6px',
                         background: '#1877f2', color: '#fff', padding: '8px 20px',
                         borderRadius: '8px', textDecoration: 'none', fontWeight: 600, fontSize: '14px' }}
              >
                Abrir en Facebook ↗
              </a>
            </div>
          )}
          {!loading && !error && posts.length === 0 && (
            <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280', fontSize: '14px' }}>
              No se encontraron publicaciones para esta página.
            </div>
          )}
          {!loading && !error && posts.length > 0 && (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                  <th style={{ padding: '10px 12px', textAlign: 'left', width: '48px' }}>#</th>
                  <th style={{ padding: '10px 8px', width: '72px' }}>Imagen</th>
                  <th style={{ padding: '10px 8px', textAlign: 'left' }}>Publicación</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', width: '90px' }}>📅 Fecha</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', width: '90px' }}>👍 Reacciones</th>
                  <th style={{ padding: '10px 8px', textAlign: 'center', width: '100px' }}>💬 Coment.</th>
                </tr>
              </thead>
              <tbody>
                {posts.map((post, idx) => (
                  <tr key={post.id || idx}
                    style={{ borderBottom: '1px solid #f3f4f6', background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '10px 12px', color: '#9ca3af', fontWeight: 500 }}>
                      {mediaIcon(post.media_type)} {idx + 1}
                    </td>
                    <td style={{ padding: '8px' }}>
                      {post.thumbnail_url ? (
                        <a href={post.permalink} target="_blank" rel="noreferrer">
                          <img src={post.thumbnail_url} alt="post"
                            style={{ width: '56px', height: '56px', objectFit: 'cover', borderRadius: '6px', display: 'block' }}
                            onError={(e) => { e.target.style.display = 'none'; }} />
                        </a>
                      ) : (
                        <div style={{ width: '56px', height: '56px', background: '#e7f0fd',
                                      borderRadius: '6px', display: 'flex', alignItems: 'center',
                                      justifyContent: 'center', fontSize: '20px' }}>
                          📘
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '8px', color: '#374151', lineHeight: '1.4', maxWidth: '260px' }}>
                      {post.caption ? (
                        <span title={post.caption}>
                          {post.caption.slice(0, 120)}{post.caption.length > 120 ? '…' : ''}
                        </span>
                      ) : (
                        <span style={{ color: '#d1d5db', fontStyle: 'italic' }}>Sin texto</span>
                      )}
                    </td>
                    <td style={{ padding: '8px', textAlign: 'center', color: '#6b7280' }}>{formatDate(post.timestamp)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontWeight: 600, color: '#1877f2' }}>{fmt(post.like_count)}</td>
                    <td style={{ padding: '8px', textAlign: 'center', fontWeight: 600, color: '#3b82f6' }}>{fmt(post.comment_count)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ background: '#eff4ff', borderTop: '2px solid #bfdbfe', fontWeight: 700 }}>
                  <td colSpan={4} style={{ padding: '10px 12px', color: '#374151' }}>
                    Total ({posts.length} posts)
                  </td>
                  <td style={{ padding: '10px 8px', textAlign: 'center', color: '#1877f2' }}>
                    {fmt(posts.reduce((s, p) => s + (p.like_count || 0), 0))}
                  </td>
                  <td style={{ padding: '10px 8px', textAlign: 'center', color: '#3b82f6' }}>
                    {fmt(posts.reduce((s, p) => s + (p.comment_count || 0), 0))}
                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};


const CompetenciaList = () => {
  const [competidores, setCompetidores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCompetidor, setSelectedCompetidor] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [postsTarget, setPostsTarget] = useState(null);
  const [tiktokTarget, setTiktokTarget] = useState(null);
  const [facebookTarget, setFacebookTarget] = useState(null);
  const [informeTarget, setInformeTarget] = useState(null);
  const [postsLimit, setPostsLimit] = useState(20);
  const [showLimitMenu, setShowLimitMenu] = useState(false);

  useEffect(() => {
    loadCompetidores();
  }, []);

  const loadCompetidores = async () => {
    setLoading(true);
    try {
      const response = await contentService.getCompetidores();
      const lista = Array.isArray(response.data)
        ? response.data
        : (response.data?.results || []);
      setCompetidores(lista);
    } catch (error) {
      console.error('Error loading competidores:', error);
      alert('Error al cargar cuentas de competencia');
      setCompetidores([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setSelectedCompetidor(null);
    setShowModal(true);
  };

  const handleEdit = (c) => {
    setSelectedCompetidor(c);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar esta cuenta de competencia?')) return;
    try {
      await contentService.deleteCompetidor(id);
      alert('✅ Cuenta eliminada');
      loadCompetidores();
    } catch (error) {
      console.error('Error deleting competidor:', error);
      alert('Error al eliminar cuenta');
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedCompetidor(null);
    loadCompetidores();
  };

  const filtered = competidores.filter(c =>
    c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.username?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    return name[0].toUpperCase();
  };

  const UsernameCell = ({ username, icon, onClick, color, hoverBg }) => {
    if (!username) return <span style={{ color: '#d1d5db', fontSize: '12px' }}>—</span>;
    return (
      <button
        onClick={onClick}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '5px',
          background: hoverBg, border: `1px solid ${color}30`,
          borderRadius: '20px', padding: '4px 10px',
          fontSize: '12px', fontWeight: 600, color, cursor: 'pointer',
          transition: 'all 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.opacity = '0.75'; }}
        onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
        title={`Ver publicaciones de @${username}`}
      >
        <img src={icon} alt="" style={{ width: '13px', height: '13px', objectFit: 'contain' }} />
        @{username}
      </button>
    );
  };

  const LIMIT_OPTIONS = [5, 10, 15, 20, 30];

  return (
    <div className="influencer-list-container">
      {/* Header */}
      <div className="influencer-header">
        <div>
          <h1 className="influencer-title">Competencia</h1>
          <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>
            Cuentas de Instagram, TikTok y Facebook de competidores
          </p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {/* Selector de posts por informe */}
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setShowLimitMenu(v => !v)}
              title="Configurar cantidad de posts por informe"
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                background: '#fff', border: '1px solid #d1d5db',
                borderRadius: '8px', padding: '7px 12px',
                fontSize: '13px', fontWeight: 600, color: '#374151',
                cursor: 'pointer', whiteSpace: 'nowrap',
              }}
            >
              ⚙️ Posts: <strong style={{ color: '#1d6c38' }}>{postsLimit}</strong> ▾
            </button>

            {showLimitMenu && (
              <>
                {/* Overlay para cerrar al clickear fuera */}
                <div
                  style={{ position: 'fixed', inset: 0, zIndex: 9998 }}
                  onClick={() => setShowLimitMenu(false)}
                />
                <div style={{
                  position: 'absolute', top: 'calc(100% + 6px)', right: 0,
                  background: '#fff', borderRadius: '10px', zIndex: 9999,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.15)', border: '1px solid #e5e7eb',
                  padding: '6px', minWidth: '160px',
                }}>
                  <div style={{ fontSize: '11px', color: '#9ca3af', fontWeight: 600,
                    textTransform: 'uppercase', letterSpacing: '0.05em', padding: '4px 8px 6px' }}>
                    Posts por informe
                  </div>
                  {LIMIT_OPTIONS.map(opt => (
                    <button
                      key={opt}
                      onClick={() => { setPostsLimit(opt); setShowLimitMenu(false); }}
                      style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        width: '100%', padding: '8px 12px', border: 'none',
                        borderRadius: '7px', cursor: 'pointer', fontSize: '13px', fontWeight: 600,
                        background: postsLimit === opt ? '#f0fdf4' : 'transparent',
                        color: postsLimit === opt ? '#1d6c38' : '#374151',
                        textAlign: 'left',
                      }}
                      onMouseEnter={e => { if (postsLimit !== opt) e.currentTarget.style.background = '#f9fafb'; }}
                      onMouseLeave={e => { if (postsLimit !== opt) e.currentTarget.style.background = 'transparent'; }}
                    >
                      <span>{opt} posts</span>
                      {postsLimit === opt && <span style={{ fontSize: '14px' }}>✓</span>}
                    </button>
                  ))}
                  <div style={{ margin: '6px 8px 2px', fontSize: '11px', color: '#9ca3af', borderTop: '1px solid #f3f4f6', paddingTop: '6px' }}>
                    Aplica a IG, TikTok y Facebook
                  </div>
                </div>
              </>
            )}
          </div>

          <button onClick={handleCreate} className="estado-btn">
            + Nueva Cuenta
          </button>
        </div>
      </div>

      {/* Search */}
      <div className="search-container">
        <input
          type="text"
          placeholder="🔍 Buscar por nombre o usuario..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <Loading fullScreen={false} />
      ) : (
        <>
          {filtered.length === 0 ? (
            <div className="empty-state">
              <p>📋 No se encontraron cuentas de competencia</p>
              {searchTerm ? (
                <button onClick={() => setSearchTerm('')} className="estado-btn">
                  Limpiar búsqueda
                </button>
              ) : (
                <button onClick={handleCreate} className="estado-btn" style={{ marginTop: '8px' }}>
                  + Agregar primera cuenta
                </button>
              )}
            </div>
          ) : (
            <div style={{
              background: '#fff',
              borderRadius: '12px',
              boxShadow: '0 1px 8px rgba(0,0,0,0.08)',
              overflow: 'hidden',
              border: '1px solid #e5e7eb',
            }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700, color: '#374151', width: '220px' }}>
                      Competidor
                    </th>
                    <th style={{ padding: '12px 10px', textAlign: 'center', fontWeight: 700, color: '#e1306c', width: '170px' }}>
                      <img src="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/instagram.webp"
                        alt="IG" style={{ width: '14px', height: '14px', objectFit: 'contain', verticalAlign: 'middle', marginRight: '5px' }} />
                      Instagram
                    </th>
                    <th style={{ padding: '12px 10px', textAlign: 'center', fontWeight: 700, color: '#010101', width: '170px' }}>
                      <img src="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/logo-tiktok-3.avif"
                        alt="TK" style={{ width: '14px', height: '14px', objectFit: 'contain', verticalAlign: 'middle', marginRight: '5px' }} />
                      TikTok
                    </th>
                    <th style={{ padding: '12px 10px', textAlign: 'center', fontWeight: 700, color: '#1877f2', width: '170px' }}>
                      <img src="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/faccebook.webp"
                        alt="FB" style={{ width: '14px', height: '14px', objectFit: 'contain', verticalAlign: 'middle', marginRight: '5px' }} />
                      Facebook
                    </th>
                    <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 700, color: '#374151' }}>
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((c, idx) => (
                    <tr
                      key={c.id}
                      style={{
                        borderBottom: '1px solid #f3f4f6',
                        background: idx % 2 === 0 ? '#fff' : '#fafafa',
                        transition: 'background 0.1s',
                      }}
                      onMouseEnter={e => { e.currentTarget.style.background = '#f0fdf4'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = idx % 2 === 0 ? '#fff' : '#fafafa'; }}
                    >
                      {/* Nombre */}
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{
                            width: '36px', height: '36px', borderRadius: '50%',
                            background: '#1d6c3815', color: '#1d6c38',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontWeight: 800, fontSize: '13px', flexShrink: 0, overflow: 'hidden',
                          }}>
                            {(c.profile_image_url_saved || c.profile_image_url) ? (
                              <img
                                src={c.profile_image_url_saved || c.profile_image_url}
                                alt={c.name}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.parentElement.textContent = getInitials(c.name);
                                }}
                              />
                            ) : getInitials(c.name)}
                          </div>
                          <div>
                            <div style={{ fontWeight: 700, color: '#111827', fontSize: '14px' }}>{c.name}</div>
                            {c.notes && (
                              <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '1px' }}>
                                {c.notes.slice(0, 40)}{c.notes.length > 40 ? '…' : ''}
                              </div>
                            )}
                          </div>
                        </div>
                      </td>

                      {/* Instagram */}
                      <td style={{ padding: '12px 10px', textAlign: 'center' }}>
                        <UsernameCell
                          username={c.ig_username}
                          icon="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/instagram.webp"
                          onClick={() => setPostsTarget(c)}
                          color="#e1306c"
                          hoverBg="#fff0f5"
                        />
                      </td>

                      {/* TikTok */}
                      <td style={{ padding: '12px 10px', textAlign: 'center' }}>
                        <UsernameCell
                          username={c.tk_username}
                          icon="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/logo-tiktok-3.avif"
                          onClick={() => setTiktokTarget(c)}
                          color="#010101"
                          hoverBg="#f3f4f6"
                        />
                      </td>

                      {/* Facebook */}
                      <td style={{ padding: '12px 10px', textAlign: 'center' }}>
                        <UsernameCell
                          username={c.fb_username}
                          icon="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/faccebook.webp"
                          onClick={() => setFacebookTarget(c)}
                          color="#1877f2"
                          hoverBg="#eff4ff"
                        />
                      </td>

                      {/* Acciones */}
                      <td style={{ padding: '10px 16px' }}>
                        <div style={{ display: 'flex', gap: '6px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                          {(c.ig_username || c.tk_username || c.fb_username) && (
                            <button
                              onClick={() => setInformeTarget(c)}
                              style={{
                                background: 'linear-gradient(135deg, #0f4c23, #1d6c38)',
                                color: '#fff', border: 'none', borderRadius: '7px',
                                padding: '6px 14px', fontWeight: 700, fontSize: '12px',
                                cursor: 'pointer', whiteSpace: 'nowrap',
                              }}
                            >
                              📊 Informe
                            </button>
                          )}
                          <button
                            onClick={() => handleEdit(c)}
                            style={{
                              background: '#f3f4f6', color: '#374151', border: '1px solid #e5e7eb',
                              borderRadius: '7px', padding: '6px 12px', fontSize: '12px',
                              fontWeight: 600, cursor: 'pointer',
                            }}
                          >
                            ✏️ Editar
                          </button>
                          <button
                            onClick={() => handleDelete(c.id)}
                            style={{
                              background: '#fff5f5', color: '#ef4444', border: '1px solid #fecaca',
                              borderRadius: '7px', padding: '6px 12px', fontSize: '12px',
                              fontWeight: 600, cursor: 'pointer',
                            }}
                          >
                            🗑️
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ padding: '10px 16px', background: '#f9fafb',
                borderTop: '1px solid #e5e7eb', fontSize: '12px', color: '#9ca3af' }}>
                {filtered.length} competidor{filtered.length !== 1 ? 'es' : ''}
                {searchTerm && ` · filtrando por "${searchTerm}"`}
              </div>
            </div>
          )}
        </>
      )}

      {showModal && (
        <CompetenciaModal
          competidor={selectedCompetidor}
          onClose={handleModalClose}
        />
      )}

      {postsTarget && (
        <CompetenciaPostsModal
          competidor={postsTarget}
          onClose={() => setPostsTarget(null)}
        />
      )}

      {tiktokTarget && (
        <CompetenciaTikTokModal
          competidor={tiktokTarget}
          onClose={() => setTiktokTarget(null)}
        />
      )}

      {facebookTarget && (
        <CompetenciaFacebookModal
          competidor={facebookTarget}
          onClose={() => setFacebookTarget(null)}
        />
      )}

      {informeTarget && (
        <InformeCompetidorModal
          competidor={informeTarget}
          postsLimit={postsLimit}
          onClose={() => setInformeTarget(null)}
        />
      )}
    </div>
  );
};

export default CompetenciaList;
